import { createEventTracker } from '../util';
import {
  RetentionActionsAnalytics,
  RetentionViewedAnalytics,
  RetentionArchivedAnalytics,
  RetentionExploredAnalytics,
  RetentionSavedAnalytics,
} from './types';

export const trackRetentionViewed =
  createEventTracker<RetentionViewedAnalytics>('Retention Viewed');
export const trackRetentionSaved = createEventTracker<RetentionSavedAnalytics>('Retention Saved');
export const trackRetentionArchived =
  createEventTracker<RetentionArchivedAnalytics>('Retention Archived');
export const trackRetentionExplored =
  createEventTracker<RetentionExploredAnalytics>('Retention Explored');
export const trackRetentionAddToDashboard = createEventTracker<RetentionActionsAnalytics>(
  'Retention Add To Dashboard',
);
